import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TBackgroundJob } from "../types";

type JobListParams = { queue?: string; status?: string; page?: number; limit?: number };
type JobCallbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export const useBackgroundJobList = (qData: JobListParams = { limit: 50 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.BACKGROUND_JOB, qData],
    queryFn: () => client.get(API_ENDPOINTS.BACKGROUND_JOB, { params: qData }),
    select: (res: any) => ({
      data: res.data.data as TBackgroundJob[],
      extra: res.data.extra as { total: number; page: number; limit: number },
    }),
    refetchOnWindowFocus: false,
  });
};

export const useBackgroundJobCancel = ({ onSuccess, onError }: JobCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.put(API_ENDPOINTS.BACKGROUND_JOB_CANCEL(id), {}),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.BACKGROUND_JOB] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useBackgroundJobRetry = ({ onSuccess, onError }: JobCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.put(API_ENDPOINTS.BACKGROUND_JOB_RETRY(id), {}),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.BACKGROUND_JOB] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};
